import type { EnumUnion } from '@dresscode-frontend/utility-types';

import type { WorkerTypeKind } from '@/components/FilterChip';
import { WorkerType } from '@/constants/workerType';
import type { ApiResponseBody } from '@/lib/api/api-type-helper';

export type FilterKey = Exclude<
  keyof ApiResponseBody<'/v2/people/count', 'get'>,
  | 'EMPLOYEE_ALUMNI'
  | 'BOARD_ALUMNI'
  | 'CONTRACTOR_ALUMNI'
  | 'COLLABORATOR_ALUMNI'
  | 'ALL_ALUMNI'
  // TODO: 契約更新（CONTRACTOR_RENEWAL_UPCOMING, ALL_RENEWAL_UPCOMING）は機能が揃ってから再開
  | 'CONTRACTOR_RENEWAL_UPCOMING'
  | 'ALL_RENEWAL_UPCOMING'
  // TODO: 正社員カテゴリ（REGULAR_ALL, REGULAR_JOINING）は従業員一覧UIに表示する要件が来たら追加
  | 'REGULAR_ALL'
  | 'REGULAR_JOINING'
>;
export const FilterKey = {
  // Employees: 従業員
  EMPLOYEE_ALL: 'EMPLOYEE_ALL', // すべて
  EMPLOYEE_JOINING: 'EMPLOYEE_JOINING', // 入社予定
  EMPLOYEE_OFFERED: 'EMPLOYEE_OFFERED', // オファー済み
  EMPLOYEE_OFFER_ACCEPTED: 'EMPLOYEE_OFFER_ACCEPTED', // オファー承認済み
  EMPLOYEE_ACTIVE: 'EMPLOYEE_ACTIVE', // 在籍中
  EMPLOYEE_NEW_HIRE: 'EMPLOYEE_NEW_HIRE', // 新入社員
  EMPLOYEE_LEAVING: 'EMPLOYEE_LEAVING', // 退社予定

  // Board: 取締役・役員
  BOARD_ALL: 'BOARD_ALL', // すべて
  BOARD_JOINING: 'BOARD_JOINING', // 入場予定
  BOARD_OFFERED: 'BOARD_OFFERED', // オファー済み
  BOARD_OFFERED_ACCEPTED: 'BOARD_OFFERED_ACCEPTED', // オファー承認済み
  BOARD_ACTIVE: 'BOARD_ACTIVE', // 在籍中
  BOARD_NEWBIE: 'BOARD_NEWBIE', // 入場から1ヶ月
  BOARD_LEAVING: 'BOARD_LEAVING', // 退場予定

  // Contractor: 業務契約者
  CONTRACTOR_ALL: 'CONTRACTOR_ALL', // すべて
  CONTRACTOR_JOINING: 'CONTRACTOR_JOINING', // 入場予定
  CONTRACTOR_OFFERED: 'CONTRACTOR_OFFERED', // オファー済み
  CONTRACTOR_OFFERED_ACCEPTED: 'CONTRACTOR_OFFERED_ACCEPTED', // オファー承認済み
  CONTRACTOR_ACTIVE: 'CONTRACTOR_ACTIVE', // 在籍中
  CONTRACTOR_NEWBIE: 'CONTRACTOR_NEWBIE', // 新入社員
  CONTRACTOR_LEAVING: 'CONTRACTOR_LEAVING', // 退場予定

  // Collaborator: 協力者
  COLLABORATOR_ALL: 'COLLABORATOR_ALL', // すべて

  // マージしたもの
  ALL_ALL: 'ALL_ALL', // すべて
  ALL_JOINING: 'ALL_JOINING', // 入社・入場予定
  ALL_OFFERED: 'ALL_OFFERED', // オファー済み
  ALL_OFFERED_ACCEPTED: 'ALL_OFFERED_ACCEPTED', // オファー承認済み
  ALL_ACTIVE: 'ALL_ACTIVE', // 在籍中
  ALL_NEWBIE: 'ALL_NEWBIE', // 入社・入場から1ヶ月
  ALL_LEAVING: 'ALL_LEAVING', // 退社・退場予定
} as const satisfies Record<FilterKey, FilterKey>;

export const TabKey = {
  EMPLOYEE: 'Employee',
  BOARD: 'Board',
  CONTRACTOR: 'Contractor',
  COLLABORATOR: 'Collaborator',
  ALL: 'All',
} as const;
export type TabKey = EnumUnion<typeof TabKey>;

/**
 * TabKeyからWorkerTypeKindへのマッピング
 * TabKey.ALLの場合はundefinedを返し、すべてのWorkerTypeを表示する
 */
export const TabKeyToWorkerTypeKind: Record<TabKey, WorkerTypeKind> = {
  [TabKey.EMPLOYEE]: WorkerType.EMPLOYEE,
  [TabKey.BOARD]: WorkerType.BOARD_MEMBER,
  [TabKey.CONTRACTOR]: WorkerType.CONTRACTOR,
  [TabKey.COLLABORATOR]: WorkerType.COLLABORATOR,
  [TabKey.ALL]: undefined,
};
